var exports = {
  "kL": "KeybindsTab.module__container___VGhoWl",
  "ft": "KeybindsTab.module__containerCompact___VGhoWl",
  "Pc": "KeybindsTab.module__searchRow___VGhoWl",
  "Vw": "KeybindsTab.module__customSection___VGhoWl",
  "P_": "KeybindsTab.module__customHeader___VGhoWl",
  "yy": "KeybindsTab.module__customHeaderText___VGhoWl",
  "_U": "KeybindsTab.module__customTitle___VGhoWl",
  "Mu": "KeybindsTab.module__customSubtitle___VGhoWl",
  "DK": "KeybindsTab.module__shortcutOptions___VGhoWl",
  "sC": "KeybindsTab.module__shortcutOption___VGhoWl",
  "wm": "KeybindsTab.module__customList___VGhoWl",
  "Kl": "KeybindsTab.module__customRow___VGhoWl",
  "YI": "KeybindsTab.module__customRowDisabled___VGhoWl",
  "Of": "KeybindsTab.module__customHeaderActions___VGhoWl",
  "DN": "KeybindsTab.module__dotsButton___VGhoWl",
  "D2": "KeybindsTab.module__customRowMain___VGhoWl",
  "EG": "KeybindsTab.module__customField___VGhoWl",
  "gF": "KeybindsTab.module__customFieldLabel___VGhoWl",
  "Ou": "KeybindsTab.module__customControls___VGhoWl",
  "dD": "KeybindsTab.module__customHint___VGhoWl",
  "p$": "KeybindsTab.module__emptyState___VGhoWl",
  "Z8": "KeybindsTab.module__conflictWarning___VGhoWl",
  "se": "KeybindsTab.module__conflictIcon___VGhoWl",
  "rs": "KeybindsTab.module__defaultsList___VGhoWl",
  "WX": "KeybindsTab.module__defaultsSection___VGhoWl",
  "Mz": "KeybindsTab.module__defaultsSectionTitle___VGhoWl",
  "DC": "KeybindsTab.module__defaultsSectionRows___VGhoWl",
  "Bq": "KeybindsTab.module__defaultChipsMerged___VGhoWl",
  "r1": "KeybindsTab.module__defaultChips___VGhoWl",
  "_R": "KeybindsTab.module__defaultRow___VGhoWl",
  "pc": "KeybindsTab.module__defaultRowActions___VGhoWl",
  "AB": "KeybindsTab.module__defaultLabel___VGhoWl",
  "q3": "KeybindsTab.module__defaultChipsEmpty___VGhoWl",
  "Oo": "KeybindsTab.module__defaultChip___VGhoWl",
  "V": "KeybindsTab.module__permissionSectionHelper___VGhoWl",
  "FG": "KeybindsTab.module__systemShortcutsCommands___VGhoWl",
};

module.exports = exports;
